import Siema from './siema';

import ogimg from '../img/og_img.jpg';
import farm1_1920 from '../img/gameplay/farm1_1920.jpg';
import farm1_1920webp from '../img/gameplay/farm1_1920.webp';
import farm1_1280 from '../img/gameplay/farm1_1280.jpg';
import farm1_1280webp from '../img/gameplay/farm1_1280.webp';
import farm1_640 from '../img/gameplay/farm1_640.jpg';
import farm1_640webp from '../img/gameplay/farm1_640.webp';
import battle_leii_640 from '../img/home/battle_leii_640.jpg';
import battle_leii_640webp from '../img/home/battle_leii_640.webp';
import battle_leii_1280 from '../img/home/battle_leii_1280.jpg';
import battle_leii_1280webp from '../img/home/battle_leii_1280.webp';
import battle_leii_1920 from '../img/home/battle_leii_1920.jpg';
import battle_leii_1920webp from '../img/home/battle_leii_1920.webp';
import battle_leii_640gp from '../img/gameplay/battle_leii_640.jpg';
import battle_leii_640webpgp from '../img/gameplay/battle_leii_640.webp';
import battle_leii_1280gp from '../img/gameplay/battle_leii_1280.jpg';
import battle_leii_1280webpgp from '../img/gameplay/battle_leii_1280.webp';
import battle_leii_1920gp from '../img/gameplay/battle_leii_1920.jpg';
import battle_leii_1920webpgp from '../img/gameplay/battle_leii_1920.webp';
import agri_1920 from '../img/gameplay/agribuddies_1920.jpg';
import agri_1920webp from '../img/gameplay/agribuddies_1920.webp';
import agri_1280 from '../img/gameplay/agribuddies_1280.jpg';
import agri_1280webp from '../img/gameplay/agribuddies_1280.webp';
import agri_640 from '../img/gameplay/agribuddies_640.jpg';
import agri_640webp from '../img/gameplay/agribuddies_640.webp';
import research_1920 from '../img/gameplay/research_1920.jpg';
import research_1920webp from '../img/gameplay/research_1920.webp';
import research_1280 from '../img/gameplay/research_1280.jpg';
import research_1280webp from '../img/gameplay/research_1280.webp';
import research_640 from '../img/gameplay/research_640.jpg';
import research_640webp from '../img/gameplay/research_640.webp';
import elementals_1920 from '../img/gameplay/elementals_1920.jpg';
import elementals_1920webp from '../img/gameplay/elementals_1920.webp';
import elementals_1280 from '../img/gameplay/elementals_1280.jpg';
import elementals_1280webp from '../img/gameplay/elementals_1280.webp';
import elementals_640 from '../img/gameplay/elementals_640.jpg';
import elementals_640webp from '../img/gameplay/elementals_640.webp';
import training_1920 from '../img/gameplay/training_1920.jpg';
import training_1920webp from '../img/gameplay/training_1920.webp';
import training_1280 from '../img/gameplay/training_1280.jpg';
import training_1280webp from '../img/gameplay/training_1280.webp';
import training_640 from '../img/gameplay/training_640.jpg';
import training_640webp from '../img/gameplay/training_640.webp';
import treat_1920 from '../img/gameplay/treat_1920.jpg';
import treat_1920webp from '../img/gameplay/treat_1920.webp';
import treat_1280 from '../img/gameplay/treat_1280.jpg';
import treat_1280webp from '../img/gameplay/treat_1280.webp';
import treat_640 from '../img/gameplay/treat_640.jpg';
import treat_640webp from '../img/gameplay/treat_640.webp';
import battleten_1920 from '../img/gameplay/battle_ten_1920.jpg';
import battleten_1920webp from '../img/gameplay/battle_ten_1920.webp';
import battleten_1280 from '../img/gameplay/battle_ten_1280.jpg';
import battleten_1280webp from '../img/gameplay/battle_ten_1280.webp';
import battleten_640 from '../img/gameplay/battle_ten_640.jpg';
import battleten_640webp from '../img/gameplay/battle_ten_640.webp';
import fairyskill_1920 from '../img/gameplay/fairyskill_1920.jpg';
import fairyskill_1920webp from '../img/gameplay/fairyskill_1920.webp';
import fairyskill_1280 from '../img/gameplay/fairyskill_1280.jpg';
import fairyskill_1280webp from '../img/gameplay/fairyskill_1280.webp';
import fairyskill_640 from '../img/gameplay/fairyskill_640.jpg';
import fairyskill_640webp from '../img/gameplay/fairyskill_640.webp';
import fusionsummon_1920 from '../img/gameplay/fusion_summon_1920.jpg';
import fusionsummon_1920webp from '../img/gameplay/fusion_summon_1920.webp';
import fusionsummon_1280 from '../img/gameplay/fusion_summon_1280.jpg';
import fusionsummon_1280webp from '../img/gameplay/fusion_summon_1280.webp';
import fusionsummon_640 from '../img/gameplay/fusion_summon_640.jpg';
import fusionsummon_640webp from '../img/gameplay/fusion_summon_640.webp';
import unite_1920 from '../img/gameplay/unite_1920.jpg';
import unite_1920webp from '../img/gameplay/unite_1920.webp';
import unite_1280 from '../img/gameplay/unite_1280.jpg';
import unite_1280webp from '../img/gameplay/unite_1280.webp';
import unite_640 from '../img/gameplay/unite_640.jpg';
import unite_640webp from '../img/gameplay/unite_640.webp';

let canIClickGameplay = true;
const gameplaySelectors = document.querySelectorAll('.gameplay__selector__top');
const gameplayBtns = document.querySelectorAll('.btn__clicked');
const farm = document.getElementById('farm');
const ranch = document.getElementById('ranch');
const battle = document.getElementById('battle');
const shrine = document.getElementById('shrine');
const sections = [farm, ranch, battle, shrine];

const showCorrectGameplaySection = sectionToShow => {
  sections.forEach(item => {
    item.classList.add('gameplay__hide');
  });
  switch (sectionToShow) {
    case 'farm':
      farm.classList.remove('gameplay__hide');
      break;
    case 'ranch':
      ranch.classList.remove('gameplay__hide');
      break;
    case 'battle':
      battle.classList.remove('gameplay__hide');
      break;
    case 'shrine':
      shrine.classList.remove('gameplay__hide');
      break;
    default:
      farm.classList.remove('gameplay__hide');
      break;
  }
  canIClickGameplay = true;
};

const showCorrectSectionBtnClicked = btnToClick => {
  switch (btnToClick) {
    case 'farm':
      document.querySelector('[data-gameplay="farm"]').click();
      break;
    case 'ranch':
      document.querySelector('[data-gameplay="ranch"]').click();
      break;
    case 'battle':
      document.querySelector('[data-gameplay="battle"]').click();
      break;
    case 'shrine':
      document.querySelector('[data-gameplay="shrine"]').click();
      break;
    default:
      document.querySelector('[data-gameplay="farm"]').click();
      break;
  }
  window.scrollTo({ top: 300, behavior: 'smooth' });
};

// event listeners for each of the large buttons at top of page.
gameplaySelectors.forEach(selector => {
  selector.addEventListener('click', e => {
    e.preventDefault();
    if (
      canIClickGameplay &&
      !e.target.classList.contains('gameplay__selector__active')
    ) {
      canIClickGameplay = false;
      document
        .querySelector('.gameplay__selector__active')
        .classList.remove('gameplay__selector__active');
      selector.classList.add('gameplay__selector__active');
      const gameplaySelected = selector.dataset.gameplay;
      showCorrectGameplaySection(gameplaySelected);
    }
  });
});

// event handler for large buttons on gameplay page within the sections.
gameplayBtns.forEach(btn => {
  document.body.addEventListener('click', evt => {
    if (btn.contains(evt.target)) {
      evt.preventDefault();
      const gameplaySelected = btn.closest('.btn__clicked').dataset.gameplay;
      showCorrectSectionBtnClicked(gameplaySelected);
    }
  });
});

//  replace <a> tag .jpg in media section with .webp files if webp is safe to use.
const isWebpAvailable = document.querySelector('html');
if (isWebpAvailable.classList.contains('webp')) {
  let singleSrc;
  let multilineSrc;
  document.querySelectorAll('.gameplay__sm__box__contents a').forEach(elem => {
    multilineSrc = elem.dataset.srcset.replace(/jpg/g, 'webp').trim();
    singleSrc = elem.dataset.src.replace('jpg', 'webp');
    elem.dataset.srcset = multilineSrc;
    elem.dataset.src = singleSrc;
  });
}

// feature carousel using siema carousel

const gameplayCarousel = new Siema({
  perPage: {
    1: 1,
  },
  loop: false,
  duration: 400,
  selector: '.siema1',
  draggable: false,
});
let prev1 = document.querySelector('.prev1');
let next1 = document.querySelector('.next1');
prev1.addEventListener('click', () => {
  gameplayCarousel.prev(1);
});
next1.addEventListener('click', () => {
  gameplayCarousel.next(1);
});

// page setup
(() => {
  sections.forEach(section => {
    section.classList.add('gameplay__hide');
  });
  farm.classList.remove('gameplay__hide');
})();
